<div class="flex flex-col items-center">
  <h2 class="text-3xl uppercase text-blue-900 my-4 pb-1 font-bold relative" *ngIf="userService.user">
    <div class="border-b-red-700 border-l-red-700 h-full w-10 border-l-[.3rem] border-b-[.3rem] absolute"></div>
    <div class="border-r-red-700 border-t-red-700 h-[110%] w-10 border-t-[.3rem] border-r-[.3rem] absolute right-0 top-[-.4rem]"></div>
    <span class="mx-[0.6rem]">Bienvenue {{ userService.user.firstName + " " + userService.user.lastName }}</span>
  </h2>
</div>
